import { DrawerContainer } from '../../../../../../components/Drawer/DrawerContainer';
import { CarcinogenicReportWorker } from '../../types';
import { WorkerSubstancesAndMedicalExamsDrawer } from './WorkerSubstancesAndMedicalExamsDrawer';

export const WORKERS_DRAWER_ACTION_VALUES = {
    EDIT_WORKER: 'EDIT_WORKER'
};

interface DrawerManagerProps {
    open: string;
    setOpen: (value: string) => void;
    selectedWorker: CarcinogenicReportWorker | null;
    translate: (key: string) => string;
    onlyVisual: boolean;
}

const DrawerManager = ({ open, setOpen, selectedWorker, translate, onlyVisual }: DrawerManagerProps) => {
    const handleCloseDrawer = () => {
        setOpen('');
    };

    const DrawerInputManager = () => {
        switch (open) {
            case WORKERS_DRAWER_ACTION_VALUES.EDIT_WORKER:
                return (
                    <WorkerSubstancesAndMedicalExamsDrawer
                        handleCloseDrawer={handleCloseDrawer}
                        selectedWorker={selectedWorker}
                        translate={translate}
                        onlyVisual={onlyVisual}
                    />
                );

            default:
                return <></>;
        }
    };

    return (
        <DrawerContainer setOpen={setOpen} open={open} customWidth={700}>
            <DrawerInputManager />
        </DrawerContainer>
    );
};

export default DrawerManager;
